import { newToolFilterOAuthMcp } from "../oauth.ts";

export const buildkiteMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://buildkite.com/_site/favicon.png",
  url: "https://mcp.buildkite.com/mcp",
  label: "Buildkite",
});
